<template>
  <div>
    <b-modal
      v-if="useModel"
      :visible="show"
      :title="title"
      :size="size"
      centered
      hide-footer
      modal-class="frame-links-modal"
      :no-close-on-backdrop="false"
      :no-close-on-esc="false"
      body-class="p-0"
      @close="$emit('close')"
      @hidden="$emit('close')"
    >
      <div :style="{height: modalHeight}">
        <iframe
          :src="url"
          frameborder="0"
          allowfullscreen
          class="iframe-content"
          style="height: 100%; width: 100%;"
        />
      </div>
    </b-modal>
    <portal v-else
            to="dragModalTargetArea"
    >
      <dialog-drag
        v-if="show"
        :title="title"
        :options="options"
        style="z-index: 9999; cursor: move;width: calc(100vw - 100px); max-width: 1100px"
        @close="$emit('close')"
      >
        <div class="dialog-overlay">
          <iframe
            :src="url"
            frameborder="0"
            allowfullscreen
            class="iframe-content"
            style="height: 100%; width: 100%; "
          />
        </div>
      </dialog-drag>
    </portal>
  </div>
</template>

<script>
import DialogDrag from 'vue-dialog-drag'
import { BModal } from 'bootstrap-vue'

export default {
  components: {
    DialogDrag,
    BModal,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '#',
    },
    size: {
      type: String,
      default: 'md',
    },
    useModel: {
      type: Boolean,
      default: false,
    },
    modalHeight: {
      type: String,
      default: '500px',
    },
  },
  data() {
    return {
      options: { width: 1100, centered: 'viewport' },
    }
  },
}
</script>

<style scoped>
.dialog-overlay {
  width:  100%;
  height: calc(100vh - 150px);
  position: relative;
  padding: 10px;
  overflow: hidden; /* Hide anything outside the iframe */
}

.iframe-content {
  width: 100%;
  height: 100%;
  border: none;
  position: relative; /* Keep iframe within the overlay */
}
</style>
